module.exports = __webpack_public_path__ + "static/img/screenshot-5.612d4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-5.png
// module id = LIco
// module chunks = 0